import bemBlock from "@gik/core/utils/bemBlock";
import { PageSection } from "@gik/ui-legacy/gik/PageSection";
import type React from "react";

import { FeatureStepsGrid } from ".";

export const FeatureStepsSectionBlockName = "feature-steps-section";

export function FeatureStepsSection(): React.ReactElement {
	const bem = bemBlock(FeatureStepsSectionBlockName);

	return (
		<PageSection className={bem(null, null, "gik-article")}>
			<FeatureStepsGrid />
		</PageSection>
	);
}
